import { useState } from "react";
import { api, TYPE_META, TYPE_ORDER } from "@/lib/api";
import ItemCard from "@/components/ItemCard";
import { Search as SearchIcon } from "lucide-react";

const TYPES = ["all", ...TYPE_ORDER];

export default function Search() {
  const [q, setQ] = useState("");
  const [type, setType] = useState("all");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  async function run(e) {
    if (e) e.preventDefault();
    setLoading(true); setSearched(true);
    try {
      const params = {};
      if (q.trim()) params.q = q.trim();
      if (type !== "all") params.type = type;
      const r = await api.get("/items", { params });
      setResults(r.data || []);
    } finally { setLoading(false); }
  }

  return (
    <div className="space-y-10" data-testid="search-page">
      <div>
        <span className="stamp">Search</span>
        <h1 className="mt-4 font-serif-lit text-5xl tracking-tight text-[var(--ink)]">Find what you kept.</h1>
      </div>

      <form onSubmit={run} className="space-y-6" data-testid="search-form">
        <div className="flex items-center gap-3 border-b border-[rgba(44,42,40,0.2)] focus-within:border-[var(--terracotta)] transition-colors">
          <SearchIcon size={18} className="text-[var(--ink-dusty)]" strokeWidth={1.5}/>
          <input
            data-testid="search-input"
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="Title, artist, note…"
            className="flex-1 font-serif-lit text-2xl py-3 bg-transparent outline-none text-[var(--ink)]"
            autoFocus
          />
        </div>
        <div className="flex flex-wrap gap-2">
          {TYPES.map(t => (
            <button type="button" key={t} onClick={() => setType(t)} className={`chip ${type === t ? "active" : ""}`} data-testid={`search-filter-${t}`}>
              {t === "all" ? "Everything" : TYPE_META[t]?.label || t}
            </button>
          ))}
        </div>
        <button className="lc-btn" data-testid="search-submit">{loading ? "Looking…" : "Search"}</button>
      </form>

      {searched && !loading && results.length === 0 && (
        <p className="text-[var(--ink-dusty)] font-serif-lit italic">Nothing on the shelf matches that — yet.</p>
      )}

      {results.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-testid="search-results">
          {results.map((it, idx) => <ItemCard key={it.id} item={it} index={idx}/>)}
        </div>
      )}
    </div>
  );
}
